<template>
  <standard-layout :header="header">
    <template v-slot:main>
      <reservation-editor v-model="reservation"/>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import ReservationEditor from "@/components/reservation/ReservationEditor";

export default {
  data() {
    return {
      reservation: null,
      notify: true
    }
  },
  computed: {
    header() {
      return this.reservation?.number ? `Reservierung ${this.reservation.number}` : 'Neue Reservierung'
    },
    reservationDetermined() {
      return this.reservation?.startTime
          && this.reservation.duration > 0
    },
    readyForSubmission() {
      return this.reservationDetermined
          && this.reservation.customer?.email
    }
  },
  watch: {
    reservation(newVal) {
      if (newVal?.number){
        this.showInfo('Die Reservierung wurde gespeichert ')
        this.$router.push({name: 'reservationDetail', params: {id: newVal.number}})
      }
    }
  },
  components: {
    ReservationEditor,
    StandardLayout
  }
}
</script>

<style type="scss">
</style>
